import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IndividualYearGroupPerformance from "./routes/IndividualYearGroupPerformance";
export default store => {
  return {
    path: "grade",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "grade" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [IndividualYearGroupPerformance(store)],
  };
};
